import DarkFrameworkImages from '@vfgroup-oneplatform/framework/Themes/Modes/Dark/Images'

import images from '../../Images'

const Images = {
  ...DarkFrameworkImages,
  ...images,
  smsText: images.smsTextWhite,
  landline: images.landlineWhite,
  dataSharing: images.dataSharingWhite,
  offerDefaultIcon: images.offerDefaultIconWhite,
  idCard: images.idCardWhite,
  address: images.addressWhite,
  edit: images.editOrange,
  icLocationRed: images.icLocationOrange,
  icLocation: images.icLocationWhite,
  cloud: images.cloud_dark,
  fix: images.fix_dark,
  iot: images.iot_dark,
  mobile: images.mobile_dark,
  health: images.health_white,
  product: images.product_white,
  repair: images.repair_white,
  store: images.store
}

export default Images